import { useIntl } from '../../hooks';
import { type Device } from '../../types';
import { Button } from '../ui';

type LinkedDevicesBarProps = {
  linkedDevices: Device[];
  activeLinkedDeviceId: string | null;
  onToggle: (linkedDeviceId: string) => void;
};

export function LinkedDevicesBar({
  linkedDevices,
  activeLinkedDeviceId,
  onToggle,
}: LinkedDevicesBarProps) {
  const intl = useIntl();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-foreground">
        {intl.formatMessage({ id: 'detections.related.title' })}:
      </span>
      {linkedDevices.length === 0 ? (
        <span className="text-xs text-foreground">
          {intl.formatMessage({ id: 'detections.related.noRelatedDevices' })}
        </span>
      ) : (
        linkedDevices.map((linkedDevice) => (
          <Button
            key={linkedDevice.id}
            variant={activeLinkedDeviceId === linkedDevice.id ? 'default' : 'outline'}
            size="sm"
            className="h-7 px-2 text-xs"
            onClick={() => onToggle(linkedDevice.id)}
            aria-pressed={activeLinkedDeviceId === linkedDevice.id}
          >
            {linkedDevice.serial}{' '}
            <span className="tabular-nums">({linkedDevice.activeDetectionGroupsCount})</span>
          </Button>
        ))
      )}
    </div>
  );
}
